import { clearSession, getLogoutURL, getUserEmail } from '../auth/cognito';

export default function NoAccess() {
  const email = getUserEmail();

  function signOut() {
    clearSession();
    window.location.href = getLogoutURL();
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg,#0a0a1a,#0d1b3e,#050d1f)',
      fontFamily: "'Segoe UI',system-ui,sans-serif", padding: 24,
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 24, padding: '52px 44px', maxWidth: 480, width: '100%', textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 20 }}>🔒</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#fff', margin: '0 0 12px' }}>
          No organisation access
        </h1>
        <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.45)', lineHeight: 1.7, margin: '0 0 8px' }}>
          Your account (<span style={{ color: 'rgba(255,255,255,0.65)' }}>{email}</span>) hasn't been
          added to an organisation yet.
        </p>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', lineHeight: 1.7, margin: '0 0 36px' }}>
          Please contact your administrator to be invited, or sign in with a different account.
        </p>
        <button
          onClick={signOut}
          style={{
            padding: '12px 28px', borderRadius: 12, fontSize: 14, fontWeight: 600,
            cursor: 'pointer', border: 'none',
            background: 'rgba(99,102,241,0.8)', color: '#fff',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
